export default "__VITE_ASSET__U8Ukt0IGnmEjbjYZm7pfsQ__ 480w, __VITE_ASSET__vbqtqBA2BzbG9TS_Py1gsg__ 745w";